import { useEducationInfoControllerGetSpecialtiesQuery } from '@api/admin/adminGeneratedApi';

export const useGetSpecialties = () => {
  const { data, isLoading } = useEducationInfoControllerGetSpecialtiesQuery();

  return { data, isLoading };
};
